import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/specification_groups/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listSpecificationGroups, updateSpecificationGroup } from "../../../redux/actions/table/superadmin/specification_groups";
import EditSpecificationGroupForm from "../../../forms/superadmin/specification_groups/EditSpecificationGroupForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateSpecificationGroup(formData.id, _.omit(formData, ['id'])).then(() => {
                listSpecificationGroups();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditSpecificationGroupForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'code']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
